import HeroBanner from './HeroBanner.svelte';

export default {
  component: HeroBanner,
  name: 'Hero Banner',
  inputs: [
    {
      name: 'title',
      type: 'richText',
      defaultValue: '<h1>Hero Banner title</h1>'
    },
    {
      name: 'description',
      type: 'richText',
      defaultValue: '<p>Hero Banner description</p>'
    },
    {
      name: 'mobileCtasLabel',
      type: 'string',
      defaultValue: 'Mobile CTAs'
    },
    {
      name: 'mobileCtas',
      type: 'list',
      defaultValue: [
        {
          label: 'Button label',
          href: '#',
          kind: 'primary',
          size: 'lg'
        }
      ],
      subFields: [
        {
          name: 'label',
          type: 'string',
          defaultValue: 'Button label',
        },
        {
          name: 'iconName',
          type: 'string'
        },
        {
          name: 'href',
          type: 'string',
        },
        {
          name: 'kind',
          type: 'string',
          enum: ['primary', 'secondary', 'tertiary', 'ghost', 'ghost-alt', 'danger', 'success', 'warning']
        },
        {
          name: 'size',
          type: 'string',
          enum: ['xs', 'sm', 'md', 'lg', 'xl']
        },
      ],
    },
    {
      name: 'mobileImage',
      type: 'file',
    },
    {
      name: 'desktopCtas',
      type: 'list',
      defaultValue: [
        {
          label: 'Button label',
          href: '#',
          kind: 'primary',
          size: 'md'
        }
      ],
      subFields: [
        {
          name: 'label',
          type: 'string',
          defaultValue: 'Button label',
        },
        {
          name: 'iconName',
          type: 'string'
        },
        {
          name: 'href',
          type: 'string',
        },
        {
          name: 'kind',
          type: 'string',
          enum: ['primary', 'secondary', 'tertiary', 'ghost', 'ghost-alt', 'danger', 'success', 'warning']
        },
        {
          name: 'size',
          type: 'string',
          enum: ['xs', 'sm', 'md', 'lg', 'xl']
        },
      ],
    },
    {
      name: 'desktopImage',
      type: 'file',
    },
  ]
}